// Add your custom JS here.
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import Lenis from '@studio-freight/lenis';
import "@lottiefiles/lottie-player";
import SplitType from 'split-type';
import lity from "lity";

jQuery(document).ready(function($) {
    $('.contact-form-nav').attr('href', '#contact-form').attr('data-lity', '');
});


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        document.querySelector(".preloader").classList.add("show");

        const headingText = new SplitType('.staggerText', { types: 'lines' });

        gsap.from(headingText.lines, {
            duration: 1.5,
            yPercent: 100,
            ease: "power4",
            stagger: 0.1
        });
    }, 500);
});


gsap.registerPlugin(ScrollTrigger, Observer);

// Media query for mobile screens
const isMobile = window.matchMedia("(max-width: 767px)");

// Function to initialize Lenis
function initializeLenis() {
    let lenis = new Lenis({
        duration: 3,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: "vertical",
        gestureDirection: "vertical",
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
        autoResize: true,
    });

    lenis.on("scroll", (e) => { });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
}

// Function to check screen width and initialize Lenis if necessary
function checkScreenWidthAndInitialize() {
    if (window.matchMedia("(min-width: 768px)").matches) {
        initializeLenis();
    } else {
        // Screen width is less than or equal to 767 pixels
        //lenis is not started for mobile devices

    }
}

// Check screen width on initial load
checkScreenWidthAndInitialize();

// Add event listener for when user resizes
window.addEventListener('resize', checkScreenWidthAndInitialize);


// end of settings initial code
//start of custom code

let sections = gsap.utils.toArray(".section");
let initialColor = sections[0].getAttribute('data-color');

gsap.set('body', { backgroundColor: initialColor });

function updateColors(color) {
    const navLinks = document.querySelectorAll('.nav-item a');
    const menuPricing = document.querySelector('.menu-pricing');
    const link = document.querySelector('.menu-pricing a');
    const logoMain = document.querySelector('.custom-logo-link img');
    const menuMobile = document.querySelector('.navbar-toggler');

    if (color === '#202020') {
        navLinks.forEach(link => {
            if (!link.classList.contains('menu-pricing')) {
                link.style.color = '#ffffff'; // White text color for non-menu-pricing links
            }
        });
        link.style.color = '#F2C744'; // Orange text color for menu-pricing link
        menuPricing.style.borderColor = '#F2C744'; // Orange border color for menu-pricing section
        logoMain.src = '/wp-content/uploads/2024/02/monyads.svg'; // Update logo image source
        menuMobile.style.backgroundColor = '#ffffff';

    } else if (color === '#F2C744') {
        navLinks.forEach(link => {
            if (!link.classList.contains('menu-pricing')) {
                link.style.color = '#202020'; // White text color for non-menu-pricing links
            }
        });
        logoMain.src = '/wp-content/uploads/2024/02/monyads-dark.svg';
        link.style.color = '#ffffff'; // White text color for menu-pricing link
        menuPricing.style.borderColor = '#ffffff'; // White border color for menu-pricing section
        menuMobile.style.backgroundColor = 'transparent';

    }
}

sections.forEach(function (elem) {
    var color = elem.getAttribute('data-color');

    ScrollTrigger.create({
        trigger: elem,
        start: 'top 30%',
        end: 'bottom 80%',
        markers: false,
        onEnter: () => {
            gsap.to('body', { backgroundColor: color, duration: 0.3 });
            updateColors(color);
        },
        onLeave: () => {
            gsap.to('body', { backgroundColor: color, duration: 0.3 });
            updateColors(color);
        },
        onLeaveBack: () => {
            gsap.to('body', { backgroundColor: color, duration: 0.3 });
            updateColors(color);
        },
        onEnterBack: () => {
            gsap.to('body', { backgroundColor: color, duration: 0.3 });
            updateColors(color);
        },
    });
});



if (isMobile.matches) {
    const tl3 = gsap.timeline({
        scrollTrigger: {
            trigger: ".our-work-text",
            scrub: true,
            pin: true,
            markers: false,
            start: "-10%",
            end: "100%",
        },
    });
    tl3.fromTo(
        ".our-work-text",
        {
            opacity: 0.7,
            scale: 1,
            y: -50,
            ease: "none",
        },
        {
            opacity: 1,
            scale: 0.8,
            y: 60,
            ease: "none",
        }
    );
} else {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: ".our-work-text",
            scrub: true,
            pin: true,
            markers: false,
            start: "-10%",
            end: "+=100%",
        },
    });
    tl.fromTo(
        ".our-work-text",
        {
            scale: 1.3,
            ease: "none",
        },
        {
            scale: 0.7,
            ease: "none",
        }
    );
}


const cards = gsap.utils.toArray(".stackingcard");

cards.forEach((card, i) => {
    gsap.to(card, {
        scale: () => 0.8 + i * 0.035,
        ease: "none",
        scrollTrigger: {
            trigger: card,
            start: "top-=" + 30 * i + " 40%",
            end: "top 10%",
            scrub: true
        }
    });
    ScrollTrigger.create({
        trigger: card,
        start: "top-=" + 40 * i + " 10%",
        end: "top bottom",
        endTrigger: window.innerWidth <= 768 ? ".featured-clients-heading" : ".end-element", // Adjust the endTrigger based on device width
        pin: true,
        pinSpacing: false,
        markers: false,
        id: "card-" + i
    });
});

// Fade out after last element
if (isMobile.matches) {
    const lastCard = cards[cards.length - 1];
    gsap.to(cards, {
        opacity: 0,
        y: -200, // Move up on the y-axis
        scrollTrigger: {
            trigger: lastCard,
            start: "top 10%",
            end: "top 0%",
            scrub: true
        }
    });
}

const cursor = document.querySelector(".cursor");
const follower = document.querySelector(".cursor-follower");
const cardImages = document.querySelectorAll(".stackingcard img");
const reel = document.querySelector(".hero");

let posX = 0, posY = 0, mouseX = 0, mouseY = 0;

gsap.to({}, {
    duration: 0.02,
    repeat: -1,
    onRepeat: function () {
        posX += (mouseX - posX) / 9;
        posY += (mouseY - posY) / 9;

        gsap.set(follower, {
            left: posX - 20,
            top: posY - 20
        });

        gsap.set(cursor, {
            left: mouseX,
            top: mouseY
        });
    }
});

document.addEventListener("mousemove", (e) => {
    mouseX = e.pageX;
    mouseY = e.pageY;
});

cardImages.forEach((image) => {
    image.addEventListener("mouseenter", () => {
        cursor.classList.add("active");
        follower.classList.add("active");
    });

    image.addEventListener("mouseleave", () => {
        cursor.classList.remove("active");
        follower.classList.remove("active");
    });


});

if (document.querySelector(".hero")) {

    reel.addEventListener("mouseenter", () => {
        cursor.classList.add("active");
        follower.classList.add("active");
    });
    reel.addEventListener("mouseleave", () => {
        cursor.classList.remove("active");
        follower.classList.remove("active");
    });
}

if (window.location.href.includes('/about-us/')) {
    // select all cards
    const card_reels = document.querySelectorAll('.card-reel');

    // attach event listeners
    card_reels.forEach((card) => {
        // select video inside the card
        const video = card.querySelector('video'); // Ensure video is selected from the current card
        card.addEventListener('mouseover', () => video.play());
        card.addEventListener('mouseleave', () => video.pause());
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.featured-clients-collections');
    const containerWidth = container.scrollWidth;

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: window.innerWidth <= 768 ? ".section-featured-clients" : ".client",
            start: 'top 77%',
            end: '+=200%', // Adjusted scroll distance to 70%
            scrub: true,
            pin: true,
        }
    });

    tl.to(container, {
        x:  -containerWidth,
        ease: 'linear',
        modifiers: {
            x: gsap.utils.unitize(x => parseFloat(x) % containerWidth)
        }
    });
    if (isMobile.matches) {
        const sectionFeaturedClients = document.querySelector('.section-featured-clients');
        gsap.to(sectionFeaturedClients, {
            y: -500, // Move up on the y-axis
            scrollTrigger: {
                trigger: ".end-element",
                endTrigger: ".site-footer", // Adjust the endTrigger based on device width
                start: "top 90%",
                end: "center 30%",
                scrub: true,
                markers: false,
            }
        });
    }
});
